// import {
	
// } from './mutation-types.js'

// 执行mutations的方法
export default {
	async getSellerSignData({
		commit,
		state
	}) {
		
		
		commit();
	},
}